import { normalizeDockZone } from './constants.js';
import { resolveRootRegionFromHit } from './dockModel.js';

export function dropPayloadToHit(payload) {
    if (!payload) return null;
    return {
        tier: payload.tier || 'host',
        region: payload.region || null,
        zone: normalizeDockZone(payload.zone),
        hostType: payload.hostType || null,
        nodeId: payload.nodeId || null,
        panelId: payload.panelId || payload.targetPanelId || null,
        targetPanelId: payload.targetPanelId || payload.panelId || null,
    };
}

export function buildDropIntent(payload, context = {}, dragState = {}) {
    const hit = dropPayloadToHit(payload);
    if (!hit || !hit.zone) return null;
    const targetRootRegion = resolveRootRegionFromHit(hit, context);
    const targetScope = hit.tier === 'root' ? 'root' : 'host';
    return {
        hit,
        targetScope,
        targetRootRegion,
        targetHostId: hit.nodeId || null,
        hostZone: hit.zone,
        dropType: dragState.dragMode || 'panel',
    };
}

